import { useMemo } from 'react'

import { useLanguage } from '@/hooks/useLanguage'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAppSettings } from '@/redux/reducers/app.reducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

/** Maps the app locale to the languages the Freshworks widget supports. */
function toFreshworkLanguage(language: string) {
  if (language === 'en-US' || language === 'en-SA') return 'en'
  if (language === 'ar-SA') return 'ar'
  return language
}

/** Whether to show the Freshworks support widget, and the customer/language it is configured with. */
export function useFreshworkWidget() {
  const authUser = useAppSelector(selectAuthUser)
  const appSettings = useAppSelector(selectAppSettings)
  const language = useLanguage()

  const customer = useMemo(
    () => ({ email: authUser?.email ?? '', name: authUser?.userInfo.name + ' ' + authUser?.userInfo.surname }),
    [authUser]
  )

  return { show: appSettings.showFreshworkWidget, customer, language: toFreshworkLanguage(language) }
}
